import { useOfferModeWithFsecure } from "@nju/data-access-portal-offers/src/utils";
import type { PaymentState } from "@nju/data-access-portal-payment";
import { IScope } from "@nju/scope";
import {
  CreditCard,
  DigitalWallet,
  DigitalWalletInsufficientFunds,
} from "./partials";

interface IPaymentStatusProps {
  paymentState: PaymentState;
  isPending: boolean;
  showChangePaymentButton: boolean;
  openModal: () => void;
  variant: IScope;
  userId?: string;
}

export function PaymentStatus({
  paymentState,
  isPending,
  showChangePaymentButton,
  openModal,
  variant,
  userId,
}: IPaymentStatusProps) {
  const mode = useOfferModeWithFsecure();

  if (paymentState.type === "CREDIT_CARD") {
    return (
      <CreditCard
        isPending={isPending}
        maskedCardNumber={paymentState.maskedCardNumber}
        mode={mode}
        openModal={openModal}
        showChangePaymentButton={showChangePaymentButton}
        userId={userId}
        variant={variant}
      />
    );
  }

  if (paymentState.type === "DIGITAL_WALLET") {
    return (
      <DigitalWallet
        isPending={isPending}
        mode={mode}
        openModal={openModal}
        showChangePaymentButton={showChangePaymentButton}
        userId={userId}
        variant={variant}
      />
    );
  }

  if (paymentState.type === "DIGITAL_WALLET_INSUFFICIENT_FUNDS") {
    return (
      <DigitalWalletInsufficientFunds
        amount={paymentState.amount}
        isPending={isPending}
        mode={mode}
        openModal={openModal}
        showChangePaymentButton={showChangePaymentButton}
        userId={userId}
        variant={variant}
      />
    );
  }

  // eslint-disable-next-line unicorn/no-null
  return null;
}
